import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useUser } from '../context/UserContext';
import { Link } from 'react-router-dom';
import Footer from '../Pages/Footer';
import { API_URL } from '../config/api';

const MesCommandes = () => {
  const { user } = useUser();
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Récupérer les commandes
  useEffect(() => {
    const fetchCommandes = async () => {
      try {
        const res = await axios.get(`${API_URL}/mes-commandes/${user._id}`);
        setCommandes(res.data.commandes);
      } catch (error) {
        console.error('Erreur chargement commandes :', error);
      } finally {
        setLoading(false);
      }
    };

    if (user?._id) {
      fetchCommandes();
    }
  }, [user]);

  // Badge stylisé pour les statuts
  const getStatutBadge = (statut) => {
    const s = (statut || '').toLowerCase();
    switch (s) {
      case 'en attente':
      case 'pending':
        return { label: 'En attente', className: 'badge badge-warning' };
      case 'à livrer':
      case 'a livrer':
      case 'préparation':
      case 'preparation':
      case 'en cours':
        return { label: 'À livrer', className: 'badge badge-primary' };
      case 'livré':
      case 'livree':
      case 'livrée':
        return { label: 'Livré', className: 'badge badge-success' };
      case 'annulé':
      case 'annule':
      case 'annuler':
        return { label: 'Annulé', className: 'badge badge-danger' };
      default:
        return { label: 'Inconnu', className: 'badge badge-secondary' };
    }
  };

  // Annulation d'une commande
const handleAnnulation = async (commandeId) => {
  if (!window.confirm('Voulez-vous vraiment annuler cette commande ?')) return;
  try {
    await axios.put(`${API_URL}/annuler-commande/${commandeId}`);
    setCommandes((prev) =>
      prev.map((c) =>
        c._id === commandeId ? { ...c, status: 'annulé' } : c
      )
    );
  } catch (error) {
    console.error('Erreur lors de l’annulation :', error);
  }
};

  // Timeline visuelle de la commande
  const renderCommandesList = () => {
    if (loading) return <div className='container commandes'><p>Vous n’avez passé aucune commande.</p>;</div>;
    if (commandes.length === 0) return <div className='container commandes'><p>Vous n’avez passé aucune commande.</p>;</div>

    return (
      <div className="mes-commandes-list">
        {commandes.map((commande) => {
          const statut = (commande.statut || commande.status || '').toLowerCase();
          const badge = getStatutBadge(statut);

          return (
            <div key={commande._id} className="commande-tracking-card mb-4 p-3 border rounded">
              <div className="commande-header d-flex justify-content-between align-items-center">
                <div>
                  <h5>
                    Commande #{commande.numeroCommande || commande._id.slice(-5)}{' '}
                    <span className={badge.className}>{badge.label}</span>
                  </h5>
                  <p className="commande-date text-muted">
                    📅 {new Date(commande.createdAt).toLocaleDateString()} à {new Date(commande.createdAt).toLocaleTimeString()}
                  </p>
                </div>

                {/* {statut === 'en attente' && (
                  <button
                    onClick={() => handleAnnulation(commande._id)}
                    className="btn btn-sm btn-danger"
                  >
                    Annuler
                  </button>
                )} */}
              </div>

              {/* Timeline */}
              <div className="tracking-steps d-flex justify-content-between text-center mt-3 mb-3">
                <div className={`step ${statut === 'en attente' ? 'active' : ''}`}>
                  <span>📦</span>
                  <p>Commande reçue</p>
                </div>
                <div className={`step ${['à livrer', 'a livrer', 'préparation', 'en cours'].includes(statut) ? 'active' : ''}`}>
                  <span>🚚</span>
                  <p>Préparation</p>
                </div>
                <div className={`step ${['livrée', 'livree', 'livré'].includes(statut) ? 'active' : ''}`}>
                  <span>✅</span>
                  <p>Livrée</p>
                </div>
                <div className={`step ${['annulé', 'annule', 'annuler'].includes(statut) ? 'active' : ''}`}>
                  <span>❌</span>
                  <p>Annulée</p>
                </div>
              </div>

              <div className="commande-body">
                <h6>Articles :</h6>
                <ul>
                  {commande.cart.map((item, idx) => (
                    <li key={idx}>
                      {item.title} – {item.quantity} × {item.price} F CFA
                    </li>
                  ))}
                </ul>
                <p className="total mt-2">
                  Total : <strong>{commande.totalAmount} F CFA</strong>
                </p>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Mes commandes</li>
          </ol>
        </nav>

        <h2 className="mb-4">Mes commandes</h2>
        {renderCommandesList()}
      </div>

      <Footer />
    </>
  );
};

export default MesCommandes;